module.exports = __webpack_public_path__ + "static/media/regiao_nordeste.f8ff8055.svg";